/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type TravelLogResponse = {
  id: number
  event_id?: number
  distance_in_km?: number
  net_expenses_in_cent?: number
  tax_in_cent?: number
  currency?: string
  vehicle_type?: TravelLogResponse.vehicle_type
  comment?: string
  km_reading_start?: number
  km_reading_end?: number
  license_plate?: string
  files?: Array<{
    id: number
    web_path: string
    mime_type?: string
    name: string
  }>
}
export namespace TravelLogResponse {
  export enum vehicle_type {
    PRIVATE_CAR = 'private_car',
    COMPANY_CAR = 'company_car',
    RENTAL_CAR = 'rental_car',
    TAXI = 'taxi',
    PUBLIC_TRANSPORTATION = 'public_transportation',
    AIRPLANE = 'airplane',
    TRAIN = 'train',
    OTHER = 'other',
  }
}
